import React from 'react';
import { ChartConfig } from '../types';

type CustomTooltipProps = {
  active?: boolean;
  payload?: any[];
  config: ChartConfig;
};

export const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload, config }) => {
  if (active && payload && payload.length) {
    const dataPoint = payload[0].payload;
    const value = dataPoint.value;
    return (
      <div className="bg-white p-3 border border-gray-300 rounded-md shadow-lg">
        <p className="font-medium">{`日付: ${dataPoint.date}`}</p>
        <p className="text-blue-600">
          {value !== null 
            ? `${config.title}: ${payload[0].value}${config.unit}`
            : `${config.title}: データなし`
          }
        </p>
      </div>
    );
  }
  return null;
};
